import React from 'react';
import './Landing.css';
const Landing = ({ onLoginClick, onRegisterClick, onNavigate }) => {

    return (
        <div className="landing">

            {/* NAVBAR */}
            <header className="landing-navbar">
                <div className="navbar-container">
                    <div className="navbar-logo">
                        <span className="logo-icon">📍</span> LOTEA
                    </div>

                    <nav className="navbar-links">
                        <a href="#features">Características</a>
                        <a href="#pricing">Planes</a>
                        <a href="#testimonials">Testimonios</a>
                        <a href="#contact">Contacto</a>
                    </nav>

                    <div className="navbar-actions">
                        <button onClick={onLoginClick} className="btn-link">
                            Iniciar sesión
                        </button>
                        <button onClick={onRegisterClick} className="btn-primary">
                            Comenzar gratis
                        </button>
                    </div>
                </div>
            </header>

            {/* HERO */}
            <section className="landing-hero">
                <span className="landing-badge">✨ La plataforma #1 para gestión de lotes</span>

                <h1>
                    Gestiona tus proyectos inmobiliarios
                    con <span>precisión</span> y <span>velocidad</span>
                </h1>

                <p className="lead">
                    LOTEA es la solución SaaS diseñada para inmobiliarias, constructoras y corredores.
                    Visualiza planos interactivos, organiza lotes y cierra ventas más rápido.
                </p>

                <div className="landing-actions">
                        <button
                            onClick={onRegisterClick}
                            className="btn-primary btn-large"
                        >
                            Usar LOTEA gratis
                        </button>
                    <button onClick={onLoginClick} className="btn-secondary btn-large">
                        Ver demostración
                    </button>
                </div>

                <p className="hero-subtext">No requiere tarjeta de crédito • Acceso inmediato</p>
            </section>
            {/* FEATURES */}
            <section className="landing-features" id="features">
                <h2>¿Por qué elegir LOTEA?</h2>

                <div className="features-grid">
                    <div className="feature">
                        <div className="feature-icon">🗺️</div>
                        <h3>Plano Interactivo</h3>
                        <p>
                            Visualiza y edita todos tus lotes en un plano interactivo.
                            Gestión intuitiva y en tiempo real.
                        </p>
                    </div>

                    <div className="feature">
                        <div className="feature-icon">🔐</div>
                        <h3>Seguridad Enterprise</h3>
                        <p>
                            Autenticación JWT, encriptación de datos y acceso controlado por roles.
                            Tus datos están protegidos.
                        </p>
                    </div>

                    <div className="feature">
                        <div className="feature-icon">📊</div>
                        <h3>Dashboard Avanzado</h3>
                        <p>
                            Métricas en tiempo real, estadísticas de ventas y disponibilidad.
                            Toma decisiones informadas.
                        </p>
                    </div>

                    <div className="feature">
                        <div className="feature-icon">⚡</div>
                        <h3>Rendimiento Ultra Rápido</h3>
                        <p>
                            Infraestructura en la nube con respuesta instantánea.
                            Sin tiempos de espera.
                        </p>
                    </div>

                    <div className="feature">
                        <div className="feature-icon">🤖</div>
                        <h3>Automatización Inteligente</h3>
                        <p>
                            Automatiza tareas repetitivas y enfócate en lo que importa.
                            Ahorra horas cada semana.
                        </p>
                    </div>

                    <div className="feature">
                        <div className="feature-icon">📱</div>
                        <h3>Disponible en Cualquier Dispositivo</h3>
                        <p>
                            Acceso desde desktop, tablet o móvil.
                            Gestiona tu negocio desde cualquier lugar.
                        </p>
                    </div>
                </div>
            </section>

            {/* PRICING (deshabilitado: actualmente sin planes ni suscripciones) */}
            <section className="landing-pricing" id="pricing">
                <h2>Uso sencillo, sin planes</h2>
                <p className="pricing-subtitle">
                    Actualmente LOTEA se ofrece como una única versión del sistema, sin planes ni suscripciones.
                    Regístrate e ingresa para empezar a gestionar tus lotes directamente.
                </p>
            </section>

            {/* TESTIMONIOS */}
            <section className="landing-testimonials" id="testimonials">
                <h2>Lo que dicen nuestros usuarios</h2>

                <div className="testimonials-grid">
                    <div className="testimonial">
                        <p>
                            “Con LOTEA organizamos más de 250 lotes en un solo
                            panel. El plano interactivo nos ahorró horas.”
                        </p>
                        <div className="testimonial-author">
                            <div className="avatar">CM</div>

                            <div className="author-info">
                                <strong>— Carlos Méndez</strong>
                                <span>Gerente Inmobiliario</span>
                            </div>
                        </div>
                    </div>

                    <div className="testimonial">
                        <p>
                            “Ideal para mostrar disponibilidad en tiempo real.
                            Muy clara y fácil de usar.”
                        </p>
                        <div className="testimonial-author">
                            <div className="avatar">AR</div>

                            <div className="author-info">
                                <strong>— Ana Rodríguez</strong>
                                <span>Corredora de Bienes Raíces</span>
                            </div>
                        </div>
                    </div>

                    <div className="testimonial">
                        <p>
                            “Buscábamos algo simple y seguro. LOTEA cumplió
                            exactamente lo que necesitábamos.”
                        </p>
                        <div className="testimonial-author">
                            <div className="avatar">LP</div>

                            <div className="author-info">
                                <strong>— Luis Paredes</strong>
                                <span>Constructora Urbana</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* STEPS */}
            <section className="landing-steps">
                <h2>Empieza en 3 pasos</h2>

                <ol>
                    <li>Crea tu cuenta en menos de un minuto.</li>
                    <li>Accede a tu panel de control.</li>
                    <li>Registra y gestiona tus lotes fácilmente.</li>
                </ol>
            </section>

            <footer className="landing-footer-extended" id="contact">
                <div className="footer-grid">

                    {/* BRANDING */}
                    <div>
                        <h4>LOTEA</h4>
                        <p>
                            Plataforma moderna para la gestión visual
                            de lotes inmobiliarios.
                        </p>
                    </div>

                    {/* CONTACTO */}
                    {/* <div>
                        <h4>Contacto</h4>
                        <p>
                            ¿Tienes preguntas o quieres una demostración?
                            Escríbenos y te responderemos pronto.
                        </p>

                        <ul className="footer-contact">
                            <li>📧 lotea.app@gmail.com</li>
                            <li>📍 Perú</li>
                        </ul>

                        <button
                            onClick={onRegisterClick}
                            className="btn-primary footer-cta"
                        >
                            Solicitar demo
                        </button>
                    </div> */}

                    {/* PRODUCTO */}
                    <div>
                        <h4>Producto</h4>
                        <ul>
                            <li>Plano interactivo</li>
                            <li>Dashboard</li>
                            <li>Gestión de lotes</li>
                        </ul>
                    </div>
                    {/* RECURSOS */}
                    <div>
                        <h4>Recursos</h4>
                        <ul>
                            {/* <li>
                                <button className="footer-link" onClick={() => onNavigate && onNavigate('documentacion')}>Documentación</button>
                            </li> */}
                            <li>
                                <button className="footer-link" onClick={() => onNavigate && onNavigate('soporte')}>Soporte</button>
                            </li>
                            <li>
                                <button className="footer-link" onClick={() => onNavigate && onNavigate('faq')}>Preguntas frecuentes</button>
                            </li>
                        </ul>
                    </div>
                    {/* LEGAL */}
                    <div>
                        <h4>Legal</h4>
                        <ul>
                            <li>
                                <button className="footer-link" onClick={() => onNavigate && onNavigate('terminos')}>Términos y condiciones</button>
                            </li>
                            <li>
                                <button className="footer-link" onClick={() => onNavigate && onNavigate('privacidad')}>Política de privacidad</button>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="footer-bottom">
                    © {new Date().getFullYear()} LOTEA. Todos los derechos reservados.
                    <span className="footer-separator">•</span>
                    Desarrollado por{" "}
                    <a
                        href="https://ruvaldev.vercel.app"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="footer-link"
                    >
                        Ruval.Dev
                    </a>
                </div>
            </footer>
        </div>
    );
};

export default Landing;
